/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/transfer_to_medium'
export default icon
